/* istanbul ignore file */

import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'

import * as Styles from './styles'

const RefundMethodsPieChart = ({ data }) => {
  const { t } = useTranslation()

  const renderCustomLabel = ({ cx, cy, midAngle, outerRadius, Icon, bulletColor, iconType, label }) => {
    const RADIAN = Math.PI / 180
    const radius = outerRadius + 10

    const iconOffset = 18
    const iconX = cx + (radius + iconOffset) * Math.cos(-midAngle * RADIAN)
    const iconY = cy + (radius + iconOffset) * Math.sin(-midAngle * RADIAN)

    return (
      <>
        <foreignObject x={iconX - 10} y={iconY - 10} width={20} height={20}>
          <Tooltip title={t(label)}>
            <Icon color={bulletColor} type={iconType} />
          </Tooltip>
        </foreignObject>
      </>
    )
  }

  return (
    <Styles.ChartContainer>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            offset={0}
            data={data}
            innerRadius={64}
            outerRadius={88}
            dataKey="percentage"
            label={renderCustomLabel}
            labelLine={true}
            cornerRadius={5}
          >
            {data.map((refundMethod, index) => (
              <Cell key={index} fill={refundMethod.bulletColor} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </Styles.ChartContainer>
  )
}

export default RefundMethodsPieChart
